// Import Vuetify and related features
import { createVuetify } from 'vuetify';

// Export the Vuetify instance
export default createVuetify({
  rtl: true,
  icons: {
    defaultSet: 'mdi', // Use Material Design Icons
  },
});
